import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { installerRepliGoogleMaps } from './googleMapsRepli'

// Si Google refuse la clé, les champs code postal / adresse restent saisissables.
installerRepliGoogleMaps()


// https obligatoire : une page servie en https ne peut pas appeler http —
// le navigateur bloque avant l'envoi, sans laisser de trace côté serveur.
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://api.eurekali-point.com'

createApp(App).use(store).use(router, axios).mount('#app')

